import { Route } from '@angular/router';
import { DeviceDetailsComponent } from '@features/activity-types/add-service-to-existing-device/device-details/device-details.component';
import { DeviceSelectionComponent } from '@features/activity-types/add-service-to-existing-device/device-selection/device-selection.component';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const add_service_to_existing_device_routes: Route[] = [
  {
    path: 'device-selection',
    component: DeviceSelectionComponent,
    title: 'Select Device',
    data: { order_type_id: 3 }
  },
  {
    path: 'device-details',
    component: DeviceDetailsComponent,
    title: 'Customize Device',
    data: { order_type_id: 3 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons',
    data: { order_type_id: 3 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 3 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 3 }
  },
  {
    path: '',
    redirectTo: 'device-selection',
    pathMatch: 'full'
  }
];
